// extracted by mini-css-extract-plugin
export default {"mypanel":"styles_mypanel__etw6A","validade":"styles_validade__IJj0p"};